import { render, staticRenderFns } from "./PrivilegesList.vue?vue&type=template&id=84122ca8&"
import script from "./PrivilegesList.vue?vue&type=script&lang=js&"
export * from "./PrivilegesList.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrivilegesList.vue"
export default component.exports